"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataDAPropertiesUtil = void 0;
const tslib_1 = require("tslib");
const path_1 = tslib_1.__importDefault(require("path"));
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const versionMetadata_1 = require("../../common/versionMetadata");
const telemetry_1 = require("../../common/telemetry");
const ManifestUtils_1 = require("../driver/teamsApp/utils/ManifestUtils");
class MetadataDAPropertiesUtil {
    async parseManifest(ymlPath, model, props) {
        let manifestName = path_1.default.join(versionMetadata_1.MetadataV3.teamsManifestFolder, versionMetadata_1.MetadataV3.teamsManifestFileName);
        const action = model.provision?.driverDefs.find((def) => def.uses === "teamsApp/zipAppPackage");
        if (action) {
            const parameters = action.with;
            if (parameters && parameters["manifestPath"]) {
                manifestName = parameters["manifestPath"];
            }
        }
        const projectRoot = path_1.default.dirname(ymlPath);
        const manifestPath = path_1.default.join(projectRoot, manifestName);
        try {
            const result = await ManifestUtils_1.manifestUtils._readAppManifest(manifestPath);
            if (result.isErr()) {
                return;
            }
            const manifest = result.value;
            const declarativeAgentRelativePath = manifest.copilotAgents?.declarativeAgents?.[0].file;
            if (declarativeAgentRelativePath) {
                const manifestFolder = path_1.default.dirname(manifestPath);
                const declarativeAgentJsonPath = path_1.default.join(manifestFolder, declarativeAgentRelativePath);
                const declarativeAgentJson = (await fs_extra_1.default.readJSON(declarativeAgentJsonPath));
                const capabilitiesCount = declarativeAgentJson.capabilities?.length ?? 0;
                props[telemetry_1.ProjectTypeProps.DeclarativeAgentCapabilitiesCount] = capabilitiesCount.toString();
                if (declarativeAgentJson.capabilities) {
                    props[telemetry_1.ProjectTypeProps.DeclarativeAgentCapabilities] = declarativeAgentJson.capabilities
                        .map((capability) => capability.name)
                        .join(",");
                }
                else {
                    props[telemetry_1.ProjectTypeProps.DeclarativeAgentCapabilities] = "";
                }
                const actionsCount = declarativeAgentJson.actions?.length ?? 0;
                props[telemetry_1.ProjectTypeProps.DeclarativeAgentActionsCount] = actionsCount.toString();
                if (declarativeAgentJson.actions) {
                    const pluginPaths = declarativeAgentJson.actions.map((action) => action.file);
                    const declarativeAgentFolder = path_1.default.dirname(declarativeAgentJsonPath);
                    const authInfo = [];
                    for (const pluginPath of pluginPaths ?? []) {
                        const pluginJsonPath = path_1.default.join(declarativeAgentFolder, pluginPath);
                        if (await fs_extra_1.default.pathExists(pluginJsonPath)) {
                            const pluginJson = (await fs_extra_1.default.readJSON(pluginJsonPath));
                            const runtimes = pluginJson.runtimes;
                            if (runtimes) {
                                const authStr = runtimes
                                    .filter((runtime) => runtime.type === "OpenApi")
                                    .map((runtime) => runtime.auth?.type)
                                    .filter((type) => type !== undefined)
                                    .join(",");
                                authInfo.push(authStr);
                            }
                        }
                    }
                    props[telemetry_1.ProjectTypeProps.DeclarativeAgentPluginAuthTypes] = authInfo.join(";");
                }
                else {
                    props[telemetry_1.ProjectTypeProps.DeclarativeAgentPluginAuthTypes] = "";
                }
            }
        }
        catch (error) {
            return;
        }
    }
}
exports.metadataDAPropertiesUtil = new MetadataDAPropertiesUtil();
//# sourceMappingURL=metadataDAProperties.js.map